__turbopack_context__.v({
  "caption": "product-video-slider-module__v3ElyG__caption",
  "card": "product-video-slider-module__v3ElyG__card",
  "dot": "product-video-slider-module__v3ElyG__dot",
  "dotActive": "product-video-slider-module__v3ElyG__dotActive",
  "dots": "product-video-slider-module__v3ElyG__dots",
  "header": "product-video-slider-module__v3ElyG__header",
  "media": "product-video-slider-module__v3ElyG__media",
  "mediaOverlay": "product-video-slider-module__v3ElyG__mediaOverlay",
  "navButton": "product-video-slider-module__v3ElyG__navButton",
  "navControls": "product-video-slider-module__v3ElyG__navControls",
  "pauseButton": "product-video-slider-module__v3ElyG__pauseButton",
  "playButton": "product-video-slider-module__v3ElyG__playButton",
  "poster": "product-video-slider-module__v3ElyG__poster",
  "posterFallback": "product-video-slider-module__v3ElyG__posterFallback",
  "posterFallbackLabel": "product-video-slider-module__v3ElyG__posterFallbackLabel",
  "section": "product-video-slider-module__v3ElyG__section",
  "title": "product-video-slider-module__v3ElyG__title",
  "track": "product-video-slider-module__v3ElyG__track",
  "video": "product-video-slider-module__v3ElyG__video",
  "videoActive": "product-video-slider-module__v3ElyG__videoActive",
  "viewport": "product-video-slider-module__v3ElyG__viewport",
  "viewportDragging": "product-video-slider-module__v3ElyG__viewportDragging",
});
